
const LikesIcon = (props: any = {}) => {
    return (
        <svg width="30" height="30" {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="#FA5A7D" />
            <path fillRule="evenodd" clipRule="evenodd" d="M8.1539 14.6987C7.34915 12.1862 8.28965 9.31449 10.9274 8.46474C12.3149 8.01699 13.8464 8.28099 14.9999 9.14874C16.0911 8.30499 17.6789 8.01999 19.0649 8.46474C21.7026 9.31449 22.6491 12.1862 21.8451 14.6987C20.5926 18.6812 14.9999 21.7487 14.9999 21.7487C14.9999 21.7487 9.4484 18.7277 8.1539 14.6987Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 11.0234C18.8025 11.2829 19.3695 11.9992 19.4378 12.8399" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default LikesIcon